export default __webpack_public_path__ + "static/media/012.fdb2b2cd.jpg";